import { cn } from '@/lib/utils/helpers/cn';

function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        'animate-pulse rounded-md bg-gray-200 dark:bg-slate-700/60',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
